import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-export-stage',
    templateUrl: './export-stage.component.html',
    styleUrls: ['./export-stage.component.css'],
    standalone: false
})
export class ExportStageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
